import { createFileRoute, useNavigate, useSearch } from "@tanstack/react-router";
import { z } from "zod";

import Clock from "@repo/icons/default/Clock";
import Left from "@repo/icons/default/Left";
import { CpsButton } from "corpus";

import {
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateRoot,
  EmptyStateTitle,
} from "@/components/ui/empty-state/empty-state";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

interface ConfirmationParams {
  action?: string;
  dominio?: string;
}

const CustomWebsiteConfirmationPage = (): JSX.Element => {
  const params: ConfirmationParams = useSearch({ from: "/custom-website/confirmation/" });

  const navigate = useNavigate();

  const handleClick = async (): Promise<void> => {
    await navigate({
      to: "/home",
    });
  };

  const title =
    params.action === "reactivate"
      ? "Reativação de domínio solicitada"
      : "Cadastro de domínio solicitado";

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Site personalizado" align="center" />
      </HeaderRoot>
      <Page>
        <div className="flex flex-col min-h-[75%] justify-center items-center">
          <EmptyStateRoot>
            <EmptyStateIcon icon={Clock} fill="primary" />
            <EmptyStateTitle>{title}</EmptyStateTitle>
            <EmptyStateDescription>
              Seu site {params.dominio} estará no ar dentro de algumas horas
            </EmptyStateDescription>
          </EmptyStateRoot>
          <CpsButton
            className="my-8"
            fullWidth
            color="secondary"
            onClick={() => {
              void handleClick();
            }}
          >
            Voltar para Home
          </CpsButton>
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/custom-website/confirmation/")({
  component: CustomWebsiteConfirmationPage,
  validateSearch: z.object({
    action: z.string().optional(),
    dominio: z.string().optional(),
  }),
});
